export default {
  name: 'reports',
  translationKey: 'reports-module',
  routePrefix: 'reports',
  routeNamePrefix: 'reports',
  directRoutesAvailable: true,
}
